import { T01 } from "./T01"

export const DoctorsList = {
  "sections": [
    T01
  ]
}